<script lang="ts" setup>
import { TruckStatus, TruckStatusList } from "@/constants/truck";
import { useI18n } from "vue-i18n";
import { computed } from "vue";

const { t } = useI18n();

const model = defineModel<TruckStatus | TruckStatus[]>();

const props = withDefaults(
  defineProps<{
    rules?: any[];
    label?: string;
    disabled?: boolean;
    multiple?: boolean;
  }>(),
  {
    rules: () => [],
    label: "",
    disabled: false,
    multiple: false,
  },
);

const items = computed(() => {
  return TruckStatusList.map((item) => {
    item.disabled = false;
    return item;
  });
});
</script>

<template>
  <v-select
    id="truck_status"
    v-model="model"
    :disabled="props.disabled"
    :items="items"
    :label="props.label || t('trucks.truck-status')"
    :multiple="props.multiple"
    :rules="props.rules"
    autocomplete="off"
    class="mb-0 width-100"
    color="primary"
    density="compact"
    hide-details="auto"
    item-title="name"
    item-value="id"
    variant="outlined"
  />
</template>
